// Shared reader for data/dividends.json (pons distributor epochs). All amounts arrive as
// raw 18-decimal strings; convert BigInt-safely and never invent a number.
import data from 'data/dividends.json';

// NOTE: never use ** on BigInt here — CRA/Babel rewrites it to Math.pow, which throws at runtime.
const DEC = BigInt('1' + '0'.repeat(data.decimals || 18));

export function raw(v) {
  try {
    return BigInt(String(v || '0'));
  } catch (e) {
    return BigInt(0);
  }
}
// raw 18-dec → Number with 6 decimals (small holders get 0.00xxxx MSFT — keep them visible)
export function toAmount(v) {
  const r = raw(v);
  return Number((r * BigInt(1000000)) / DEC) / 1000000;
}
export const fmtAmt = n =>
  typeof n === 'number' && isFinite(n)
    ? n.toLocaleString('en-US', { maximumFractionDigits: 6, minimumFractionDigits: n < 1 ? 4 : 2 })
    : '——';

// Derive every displayed number from one ledger object (bundled JSON or a live chain read).
export function compute(d) {
  const eps = Array.isArray(d && d.epochs) ? d.epochs : [];
  return {
    asset: (d && d.asset) || 'MSFT',
    distributor: (d && d.distributor) || null,
    updatedAt: (d && d.updatedAt) || null,
    epochs: eps,
    pendingAmount: toAmount(d && d.pending),
    // writer has run post-launch but createFor has not landed yet → surface it, never claim pons is paying
    sharingPending: !!(d && d.updatedAt) && !(d && d.distributor),
    paidTotal: eps.reduce((s, e) => s + toAmount(e.claimed), 0),
    publishedTotal: eps.reduce((s, e) => s + toAmount(e.total), 0),
  };
}

const bundled = compute(data);
export const asset = bundled.asset;
export const distributor = bundled.distributor;
export const updatedAt = bundled.updatedAt;
export const epochs = bundled.epochs;
export const pendingAmount = bundled.pendingAmount;
export const sharingPending = bundled.sharingPending;
export const paidTotal = bundled.paidTotal;
export const publishedTotal = bundled.publishedTotal;
